// Pont entre le thème club (contexte maison) et le ThemeProvider de MUI.
// À placer À L'INTÉRIEUR de ClubThemeProvider : il lit primaryColor/secondaryColor
// et construit un thème MUI qui se met à jour quand le club change.
import React, { useMemo } from 'react';
import { ThemeProvider } from '@mui/material/styles';
import { useClubTheme } from '../contexts/ClubThemeContext';
import { buildTheme } from './muiTheme';

const AppThemeProvider = ({ children }) => {
  const { primaryColor, secondaryColor } = useClubTheme();
  const theme = useMemo(
    () => buildTheme(primaryColor, secondaryColor),
    [primaryColor, secondaryColor]
  );
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default AppThemeProvider;
